import {
  CallBack,
  DataService,
  Failure,
  QueryParam,
  Success
} from "@/script/core/service/DataService";
import { BaseEntity } from "../base/IBaseEntity";
import { ServiceData } from "../base/ServiceData";

export class BaseService extends DataService {
  public serviceData: ServiceData | null = null;  

  public loadList(queryParam: QueryParam, success: Success, failure: Failure, api: string): void;
  public loadList(queryParam: QueryParam, success: Success, failure: Failure): void;
  public loadList(queryParam: QueryParam, success: Success): void;
  public loadList(
    queryParam: QueryParam,
    success: Success,
    failure?: Failure,
    api?: string,
  ) {
    if (!api) {
      api = this.serviceData?.loadListApiName!;
    }
    super.post(api, queryParam).then(
      function (result) {
        if (success) {
          success(result.data);
        }
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public loadFullList<T>(callBack: CallBack<T>) {
    if (this.serviceData) {
      super.post(this.serviceData.loadFullListApiName!, {}).then(
        function (result) {
          callBack(result.data);
        },
        function (error: Error) {
          console.error(error);
        }
      );
    }
  }

  public loadAllList(api: string, success?: Success, failure?: Failure) {
    super.post(api, {}).then(
      function (result) {
        if (success) {
          success(result.data);
        }
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public deleteList(
    api: string,
    deletedList: BaseEntity[],
    success: Success,
    failure: Failure
  ) {
    const ids: any[] = [];
    deletedList.forEach(item => {
      ids.push(item.id);
    });
    super.post(api, ids).then(
      function (result) {
        success(result.data);
      },
      function (error: Error) {
        failure(error);
      }
    );
  }

  public loadEntity(
    api: string,
    params: any,
    success: Success,
    failure?: Failure
  ) {
    super.get(api, params).then(
      function (result) {
        success(result.data);
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public saveEntity(
    api: string,
    entity: any,
    success: Success,
    failure: Failure
  ) {
    super.post(api, entity).then(
      function (result) {
        success(result.data);
      },
      function (error: Error) {
        failure(error);
      }
    );
  }
}
